module.exports = __webpack_public_path__ + "img/ic-success-serial.svg";